import {
  Badge,
  Box,
  Button,
  ButtonGroup,
  LegacyCard,
  List,
  Tag,
  Text,
  VerticalStack
} from '@shopify/polaris';
import { TCustomerConfig } from './types/TCustomerConfig';
import React from 'react';

export const Display = (props: { setInEditMode: Function, customerConfig: TCustomerConfig }) => {
  const { setInEditMode, customerConfig } = props;

  return (
    <LegacyCard>
      <LegacyCard.Section>
        <VerticalStack gap="2">
          <p>
            <Text variant="bodyMd" as="span" fontWeight="semibold">
              Tags
            </Text>
          </p>
          <p>
            <Badge status={customerConfig.tags.enabled ? "success" : "new"}>
              {customerConfig.tags.enabled ? "Enabled" : "Disabled"}
            </Badge>
          </p>
          {customerConfig.tags.enabled &&
          customerConfig.tags.tagPrefixes.length > 0 ? (
            <>
              <p>
                <Text variant="bodyMd" as="span" fontWeight="semibold">
                  Allowed tag prefixes
                </Text>
              </p>
              <p>
                {customerConfig.tags.tagPrefixes.map((prefix) => (
                  <Box padding="1" as="span" key={prefix}>
                    <Tag key={prefix} children={prefix} />
                  </Box>
                ))}
              </p>
              <p>
                <Text variant="bodyMd" as="span" fontWeight="semibold">
                  Samples
                </Text>
              </p>
              <List type="bullet">
                {customerConfig.tags.tagPrefixes.map((prefix) => (
                  <React.Fragment key={prefix}>
                    <List.Item key={prefix}>
                      <Tag key={prefix} children={prefix + ":test-value"} /> or{" "}
                      <Tag
                        key={prefix + "2"}
                        children={prefix + "test-value"}
                      />
                    </List.Item>
                  </React.Fragment>
                ))}
              </List>
            </>
          ) : null}
        </VerticalStack>
      </LegacyCard.Section>
      <LegacyCard.Section>
        <VerticalStack gap="2">
          <p>
            <Text variant="bodyMd" as="span" fontWeight="semibold">
              Metafields
            </Text>
          </p>
          <p>
            <Badge
              status={customerConfig.metafields.enabled ? "success" : "new"}
            >
              {customerConfig.metafields.enabled ? "Enabled" : "Disabled"}
            </Badge>
          </p>
          {customerConfig.metafields.enabled &&
          customerConfig.metafields.allowedMetafields.length > 0 ? (
            <>
              <p>
                <Text variant="bodyMd" as="span" fontWeight="semibold">
                  Allowed metafields
                </Text>
              </p>
              <p>
                {customerConfig.metafields.allowedMetafields.map(
                  ({ namespace, key, type}) => (
                    <Box padding="1" as="span" key={`${namespace}-${key}`}>
                      <Tag
                        key={`${namespace}:${key}`}
                        children={`${namespace}:${key} (${type})`}
                      />
                    </Box>
                  )
                )}
              </p>
            </>
          ) : null}
        </VerticalStack>
      </LegacyCard.Section>
      <LegacyCard.Section subdued>
        <ButtonGroup>
          <Button children="Edit" onClick={() => setInEditMode(true)} />
        </ButtonGroup>
      </LegacyCard.Section>
    </LegacyCard>
  );
};
